import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || '';
const baseURL = API_BASE_URL.endsWith('/api') ? API_BASE_URL : `${API_BASE_URL}/api`;

export const api = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000,
});

// 请求拦截器：自动注入登录 token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 故事相关 API
export const storyApi = {
  // 创建故事
  create: (data: {
    userId: string;
    photoUrl: string;
    theme?: string;
    targetAge?: string;
    pageCount?: number;
  }) => api.post('/stories', data),

  // 获取故事进度
  getProgress: (storyId: string) => api.get(`/stories/${storyId}/progress`),

  // 获取故事详情
  getById: (storyId: string) => api.get(`/stories/${storyId}`),

  // 获取用户的故事列表
  getUserStories: (userId: string) => api.get(`/stories/user/${userId}`),

  // 删除故事
  delete: (storyId: string) => api.delete(`/stories/${storyId}`),

  // 切换绘本公开/私有状态
  toggleVisibility: (storyId: string, isPublic: boolean) =>
    api.patch(`/stories/${storyId}/visibility`, { isPublic }),

  // 获取公开绘本列表（社区浏览）
  getPublicStories: (params?: { tags?: string; theme?: string; targetAge?: string; artStyle?: string; page?: number; pageSize?: number }) =>
    api.get('/stories/public/list', { params }),
};

export default api;
